<template>
	<div class="tickets-dashboard-graph-container" style="height: 400px">
		<div
			ref="ticketsCategoryGraph"
			style="width: 100%; height: 100%; overflow: hidden"
		></div>
	</div>
</template>

<script>
const echarts = require("echarts");
import ticketDashboardMixins from "../../../../../mixins/ticketDashboardMixins";
export default {
	name: "TicketsCategoryGraph",
	mixins: [ticketDashboardMixins],
	data() {
		return {
			ticketCategoryGraphInstance: "",
			option: {
				color: ["#D26300", "#E29D5A"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow",
					},
				},
				grid: {
					right: "15%",
					y: 40,
					y2: 100,
				},
				legend: {
					data: ["Total Tickets"],
					textStyle: {
						fontSize: "16",
					},
				},
				xAxis: [
					{
						type: "category",
						axisTick: {
							alignWithLabel: true,
						},
						// prettier-ignore
						data: [
              // 'East', 'West', 'North', 'South'
            ],
						textStyle: {
							fontSize: "16",
						},
					},
				],
				yAxis: [
					{
						type: "value",
						name: "",
            min: 0,
						interval: 50,
						max: 100,
						position: "left",
						alignTicks: true,
						axisLine: {
							show: false,
							lineStyle: {
								color: "#333333",
							},
						},
						axisLabel: {
							formatter: "{value}",
						},
					},
					{
						type: "value",
						name: "",
						min: 0,
						interval: 50,
						max: 100,
						position: "right",
						alignTicks: true,
						axisLine: {
							show: false,
							lineStyle: {
								color: "#333333",
							},
						},
						axisLabel: {
							formatter: "{value} %",
						},
					},
				],
				series: [
					{
						name: "Total Tickets",
						type: "bar",
						yAxisIndex: 0,
						barWidth: 50,
						data: [
							// 2.0, 4.9, 7.0, 23.2
						],
					},
				],
			},
		};
	},
	computed: {
		graphMaxInterVal() {
			let max = 50;
			if (this.ticket_data && this.ticket_data.length) {
				let totalTickets = this.ticket_data.map((el) => el.total);
				let topTotalTickets = Math.max(...totalTickets);
				max = topTotalTickets;
			}
			max = this.roundNearestTen(max);
			return max;
		},
	},
	watch: {
		ticket_data(newValue, oldValue) {
			this.reRenderGraph(newValue);
		},
	},
	created() {
		setTimeout(() => {
			this.initGraph();
		}, 80);
	},
	methods: {
		initGraph() {
			let chartContainer = this.$refs.ticketsCategoryGraph;
			this.ticketCategoryGraphInstance = echarts.init(chartContainer);
			this.ticketCategoryGraphInstance.setOption(this.option);
			this.ticketCategoryGraphInstance.showLoading();
		},
		reRenderGraph(data) {
			let categories = [];
			let totalTickets = [];
			let categoryPercentages = [];
			for (let i = 0; i < data.length; i++) {
				let item = data[i];
				categories.push(this.$options.filters.titleCase(item.name));
				totalTickets.push(item.total);
				// categoryPercentages.push(item.category_percentage);
			}
			// x axis labels
			this.option.xAxis[0].data = [...categories];

			this.option.yAxis[0].max = this.graphMaxInterVal;

			// Plotting total tickets data
			this.option.series[0].data = [...totalTickets];
			// Plotting category percentage data
			// this.option.series[1].data = [...categoryPercentages];
			this.ticketCategoryGraphInstance.clear();
			this.ticketCategoryGraphInstance.setOption(this.option);
			this.ticketCategoryGraphInstance.hideLoading();
		},
		roundNearestTen(num) {
			return Math.ceil(num / 5) * 5;
		},
	},
};
</script>
